import { TosItem } from '@bepatient/common';

/*
    STEPS
*/

export enum OnboardingStepTypes {
  INTRO,
  CONCLUSION,
  TOS,
  PASSWORD,
  FORM
}

export enum BirthdateFormat {
  YEAR = 'YYYY',
  YEAR_MONTH = 'YYYY/MM',
  YEAR_MONTH_FR = 'MM/YYYY',
  YEAR_MONTH_DAY = 'YYYY/MM/DD',
  YEAR_MONTH_DAY_FR = 'DD/MM/YYYY'
}

export type OnboardingSteps =
  | OnboardingStepIntro
  | OnboardingStepConclusion
  | OnboardingStepTOS
  | OnboardingStepPassword
  | OnboardingStepForm;

export interface Onboarding {
  steps: Array<OnboardingSteps>;
}

interface OnboardingStep {
  type: OnboardingStepTypes;
  stepUuid?: string;
  color: string;
  title: string;
  formValue?: any;
  buttonLabel?: any;
  uuid?: any;
}

export interface OnboardingStepIntro extends OnboardingStep {
  type: OnboardingStepTypes.INTRO;
  instanceLogo: string;
  content: string;
  buttonLabel: string;
}

export interface OnboardingStepConclusion extends OnboardingStep {
  type: OnboardingStepTypes.CONCLUSION;
  instanceLogo: string;
  image: string;
  content: string;
  buttonLabel: string;
}

export interface OnboardingStepTOS extends OnboardingStep {
  type: OnboardingStepTypes.TOS;
  uuid: string;
  subTitle: string;
  items: Array<TosItem>;
}

export interface OnboardingStepPassword extends OnboardingStep {
  buttonLabel?: string;
  color: string;
  fieldLabel?: string;
  passwordPolicy?: Array<PasswordPolicy>;
  title: string;
  type: OnboardingStepTypes.PASSWORD;
  uuid: string;
  subTitle: string;
}

export interface OnboardingStepForm extends OnboardingStep {
  type: OnboardingStepTypes.FORM;
  subTitle: string;
  questions: Array<OnboardingQuestions>;
}
export interface PasswordPolicy {
  regex: string;
  message: string;
  validated?: boolean;
}
/*
    QUESTIONS
*/

export enum OnboardingQuestionTypes {
  TEXT,
  DATE,
  RADIO,
  DATETIME
}

export type OnboardingQuestions =
  | OnboardingQuestionText
  | OnboardingQuestionDate
  | OnboardingQuestionRadio
  | OnboardingQuestionDatetime;

interface OnboardingQuestion {
  type: OnboardingQuestionTypes;
  uuid: string;
}

export interface OnboardingQuestionText extends OnboardingQuestion {
  type: OnboardingQuestionTypes.TEXT;
  label: string;
}

export interface OnboardingQuestionDate extends OnboardingQuestion {
  type: OnboardingQuestionTypes.DATE;
  label: string;
  format: string;
  mobiDateFormat: string;
  constraints: {};
}

export interface OnboardingQuestionRadio extends OnboardingQuestion {
  type: OnboardingQuestionTypes.RADIO;
  options: Array<{ value: string; label?: string; icon?: string }>;
}

export interface OnboardingQuestionDatetime extends OnboardingQuestion {
  type: OnboardingQuestionTypes.DATETIME;
  label: string;
  format: string;
}

export interface TOSDetailsType {
  type: string;
  text?: string;
  videoType?: string;
  url?: string;
}
